export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ieri"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oggi"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lunedì"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Martedì"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mercoledì"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giovedì"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Venerdì"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sabato"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Domenica"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["gennaio"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["febbraio"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["marzo"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["aprile"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["maggio"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["giugno"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["luglio"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["agosto"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["settembre"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ottobre"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["novembre"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dicembre"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tu"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amministratore"])}
}